<template>
  <div class="input-group date" ref="inputgroup">
    <input type="text" class="form-control" v-model="valueTmp" :class="errorClass"
           readonly
           :style="computedStyle"
           :disabled="disabled"
    >
    <div class="input-group-append hover-hand">
        <span class="input-group-text" :disabled="disabled">
            <i class="fa fa-calendar-alt"></i>
        </span>
    </div>
    <!--        <span class="input-group-addon"><i class="fa fa-calendar-alt"></i></span>-->
  </div>
</template>
<style scoped>
.hover-hand:hover {
  cursor: pointer;
}
</style>
<script>
import $ from 'jquery'
import moment from 'moment';
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt.min'
// import $ from 'jquery';

moment.locale('pt')

export default {
  props: {
    value: {
      default() {
        return '';
      }
    },
    startDate: {
      required: false,
      default() {
        return null;
      }
    },
    endDate: {
      required: false,
      default() {
        return null;
      }
    },
    disabled: {
      required: false,
      default() {
        return false;
      }
    },
    errorClass: {
      required: false,
      default() {
        return '';
      }
    },


  },
  data: function () {
    return {
      valueTmp: null,
    };
  },
  watch: {
    value: function () {
      this.valueTmp = this.value; // so serve para mostrar o valor inicial
      // console.log("value => " + this.value)
      this.datepicker.datepicker("update", this.value);
      this.$emit('change');
    },
  },
    computed: {
      computedStyle() {
          return this.disabled ? "" : "background-color: transparent;"
      }
    },
  mounted: function () {
    const self = this;
    this.valueTmp = this.value;
    const options = {
      format: 'yyyy-mm-dd',
      todayHighlight: true,
      // minViewMode: 1,
      language: "pt",
      autoclose: true,
    }

    if(this.startDate!= null){
      options.startDate= this.startDate
    }
    if(this.endDate!= null){
      options.endDate= this.endDate
    }

    this.datepicker = $(this.$refs.inputgroup).datepicker(options)
        .on("changeDate", function () {
          // eslint-disable-next-line
          self.$emit('update:value', moment(self.datepicker.datepicker("getDate")).format('YYYY-MM-DD'));
          // self.$emit('change');
        });
    this.datepicker.datepicker("update", this.value);
  }
}
</script>
